import { CmsIds } from "./CmsIds";

export const DefaultCms: Cms.CmsDictionary =  {
    [CmsIds.AgreeToTermsAndCond]: "I agree to the terms and conditions in the {0}",
    [CmsIds.RecieveUpdateText]: "I would like to receive updates and learn about new features and products by email. I understand I may unsubscribe at any time.",
    [CmsIds.AffiliateAgrement]: "Affiliate Agreement",
    [CmsIds.ThanksForBePartner]: "Thank you for becoming an Agoda Affiliate Partner. Please click on the link we've emailed you to confirm your email address. Note that this is mandatory for earning commissions. ",
    [CmsIds.PleaseAcknowledge]: 'Please acknowledge that you understand and consent to our affiliate agreement.',
    [CmsIds.SomethingWrong]: 'Oops! <br />Seems we are having some technical problems. <br />Please check back in a few minutes.',
    [CmsIds.BySignupTermAndPolicy]: 'By signing up, you accept our {0}, and {1}.',
    [CmsIds.Term]: 'Terms of Use',
    [CmsIds.Policy]: 'Privacy & Cookies Statement',
    [CmsIds.CreateAccount]: 'Create account',
    [CmsIds.PartnerTypeFieldLabel]: 'Partner type',
    [CmsIds.PartnerTypePlaceholder]: 'Select partner type',
    [CmsIds.PartnerTypeAffiliateLabel]: 'Affiliate',
    [CmsIds.PartnerTypeAmbassadorLabel]: 'Ambassador',
    [CmsIds.PartnerTypeRequired]: 'Please select a partner type.',
    [CmsIds.AgreementPlaceholder]: 'Select a partner type to review the agreement.',
    [CmsIds.AmbassadorAgreement]: 'Agoda Ambassador Agreement',
    [CmsIds.SignupTypePageTitle]: 'Select Partner Type to sign up',
    [CmsIds.SignupAsAffiliate]: 'Sign up as Affiliate',
    [CmsIds.SignupAsAmbassador]: 'Sign up as Agoda Ambassador',
    [CmsIds.AmbassadorInstead]: 'Want to be Agoda Ambassador instead? {0}',
    [CmsIds.AffiliateInstead]: 'Want to be Affiliate instead? {0}',
    [CmsIds.SwitchPartnerTypeClickHere]: 'Click here',
    [CmsIds.SignupTitle]: 'Signup',
}